import { HeroBrandEvolution as HeroBrandEvolutionComponent } from '@raisin/components-lib';
import { useAuthContext } from '@raisin/cp-layout';
import { getDistributor } from '@raisin/cp-utils';
import { onTrackHeroCtaClicked } from 'eventsTracking';
import React from 'react';
import { HeroBrandEvolutionProps } from '../../types';
import { getUpdatedExternalLink } from '../../utils/helpers';

export const HeroBrandEvolution: React.FC<Omit<HeroBrandEvolutionProps, 'onTrackCtaClicked'>> = (
  props,
) => {
  const { isLoggedIn } = useAuthContext();

  const commonTrackingProperties = {
    distributorId: getDistributor(),
    isLoggedIn,
  };

  const updatedData = {
    ...props,
    cta_button: {
      ...props.cta_button,
      button_link: getUpdatedExternalLink(props.cta_button?.button_link, props?.locale),
    },
  };

  const handleTrackCtaClicked = () => onTrackHeroCtaClicked(commonTrackingProperties);

  return <HeroBrandEvolutionComponent {...updatedData} onTrackCtaClicked={handleTrackCtaClicked} />;
};
